import { hubbleAPI } from './url'
const resource = hubbleAPI + '/public/ct'

export default ($axios) => ({

  /**
   * Validates the specified email address. Does a mx lookup to ensure domain
   * is accepted and uses regex to ensure proper email and adds the email to the cart
   */
  validateEmailAndAddToCart (cartID, email) {
    return $axios.post(`${resource}/validate-email-add-to-cart`, { emailAddress: email, cartID })
  },

  /**
   * Validates the specified email address with BE for a new user or play email re-usability
   */
  validateEmailForSignUp (bundleID, email) {
    return $axios.get(hubbleAPI + `/secure/public/ct/validate/signupemail/${bundleID}/${email}`)
  },

  /**
   * @todo implement voucher validation
   * Validates a voucher,
   * @param {String} voucher input
   */
  validateVoucher(voucher) {
    return $axios.get(`${resource}/email/${voucher}`)
  }

})
